

const base_url = "/api/reports";

export const downloadReport = (email, requestData) => {

    return fetch(`${base_url}/user-trips/${email}`, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify(requestData)
    }).then(results => {
        if(results.ok) {
            return results.blob();
        }

        return Promise.reject(results.json())
    });

}

export const emailReport = (email, requestData) => {

    return fetch(`${base_url}/email/user-trips/${email}`, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify(requestData)
    }).then(results => {
        if(results.ok) {
            return {};
        }

        return Promise.reject(results.json())
    });

}
